import React from 'react';

export default (Component, book, address) => (props) => (
    <Component match={{ params: { bookId: book, address } }} {...props} />
);
